import { useInstance, onMounted, onUpdated, findDomFromVNode, nextTick } from 'intact-react';
import { useState } from '../../hooks/useState';
export function useActiveBar() {
  var instance = useInstance();
  var styles = useState(null, function (lastValue, nextValue) {
    if (lastValue === null || nextValue === null) return lastValue === nextValue;
    for (var key in lastValue) {
      if (lastValue[key] !== nextValue[key]) return false;
    }
    return true;
  });
  function generateStyle() {
    var element = findDomFromVNode(instance.$lastInput, true);
    var k = instance.config.k;
    var activeTab = element.querySelector("." + k + "-tab." + k + "-active");
    if (!activeTab) {
      var oldStyles = styles.value;
      if (oldStyles) {
        styles.set(oldStyles.left ? {
          left: oldStyles.left,
          width: '0'
        } : {
          top: oldStyles.top,
          width: '0'
        });
      } else {
        styles.set(null);
      }
      return;
    }
    var vertical = instance.get('vertical');
    if (!vertical) {
      var width = activeTab.offsetWidth;
      var left = activeTab.offsetLeft;
      styles.set({
        left: left + 'px',
        width: width + 'px'
      });
    } else {
      var height = activeTab.offsetHeight;
      var top = activeTab.offsetTop;
      styles.set({
        top: top + 'px',
        height: height + 'px'
      });
    }
  }
  onMounted(generateStyle);
  // Tabs maybe embed into Transition, therefore handle style nextTick
  onUpdated(function () {
    return nextTick(generateStyle);
  });
  return styles;
}